module.exports = __webpack_public_path__ + "static/media/Padmavati.67197e04.png";